module.exports = __webpack_public_path__ + "06d05b42878adf9e9d5ca34fe1799d0e.png";